import dsbridge from 'dsbridge'
import _ from 'lodash'

// see https://codemao.yuque.com/docs/share/79eadffc-2fb1-4f52-b4f3-7c9266a9fd47?#

// js调用与原生
export const FETCH_DEVICE_INFO = 'FETCH_DEVICE_INFO' // Web调用原生获取设备信息
export const SHOW_PREVIEW = 'SHOW_PREVIEW' // 显示视频预览弹框
export const DISMISS_REMIND_BTN = 'DISMISS_REMIND_BTN' // 隐藏视频录制提示按钮
export const CLOSE_WEBVIEW = 'CLOSE_WEBVIEW' // 关闭webView

// 原生调用JS
export const SEND_IMG_INFO = 'SEND_IMG_INFO' // 监控图片交互
export const SEND_PERMISSION_RESULT = 'SEND_PERMISSION_RESULT'
export const SEND_DEVICE_INFO = 'SEND_DEVICE_INFO' // 原生返回对应的设备信息给Web

export const RETURN_DIFF_TIME = 'RETURN_DIFF_TIME' // 推送时间
export const REQUEST_DIFF_TIME = 'REQUEST_DIFF_TIME' // 获取时间毫秒数
export const DIFF_TIME_END = 'DIFF_TIME_END' // 倒计时结束
export const START_CREATION = 'START_CREATION' // 进入Nemo创作页
export const COMPLETED_CREATION = 'COMPLETED_CREATION' // 保存创作题,关闭Nemo创作页
export const FORCE_COMPLETED_CREATION = 'FORCE_COMPLETED_CREATION' // 强制结束流程
export const EXAM_COMPLETED = 'EXAM_COMPLETED' // 提交试卷

export const postMessageSyn = (type, payload = '', cb) => {
  if (!type) return
  const params = JSON.stringify({ type, payload })
  console.log(`\n【dsbridge】当前触发${type} payload => ${JSON.stringify(payload)}\n\n`)
  if (cb && typeof cb === 'function') {
    dsbridge.call('postMessageAsyn', params, cb)
  } else {
    dsbridge.call('postMessageSyn', params)
  }
}

// 函数存储映射
const fnMap = new Map()
// const isHasExecuteRegister = false // 已经执行注册

export const onPostMessageSynRegister = (type, callback) => {
  if (!type || !callback) {
    throw new Error(`type and callback is required`)
  }
  if (!fnMap.has(type)) {
    fnMap.set(type, callback)
  }
}

// 若注册事件有数据逻辑返回APP 则在组件销毁时需要解绑 建议组件销毁时均做解绑处理
export const removeOnPostMessageSynRegister = (type) => {
  if (!type) {
    throw new Error(`type is required`)
  } else {
    fnMap.delete(type)
  }
}

const onPostMessage = () => {
  dsbridge.register('postMessage', (type, data) => {
    console.log(`\n【dsbridge】onPostMessageSynRegister => 当前接受${type}回调 => data: ${JSON.stringify(data)}\n`)
    const handleFn = fnMap.get(type)
    if (!_.isEmpty(data)) {
      try {
        return handleFn && handleFn((typeof data === 'object') ? data : JSON.parse(data))
      } catch (error) {
        console.log(`解析${type}时出错, 错误：${error}, data: ${JSON.stringify(data)}`)
      }
    } else {
      return handleFn && handleFn()
    }
  })
}

export const init = () => {
  console.log('dsbridge register init')
  onPostMessage()
}

export default {
  init,
  postMessageSyn,
  onPostMessageSynRegister,
  removeOnPostMessageSynRegister
}
